import callAPiBase from './base';

const notificationsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/notificationList',
      method: 'GET',
      useToken: true,
      title: 'Notifications - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/notificationCreate',
      method: 'POST',
      useToken: true,
      title: 'Notifications - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/notificationUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Notifications - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/notificationDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Notifications - Delete',
      params,
    }),
};

export { notificationsApi };
export default notificationsApi;
